import { useEffect, useState } from 'react';

/**
 * A typed value once the typing has paused — so a filter box asks the server
 * once per word rather than once per key. The Log's filters and the businesses
 * list's search both use it; a filter applies as it is changed, with no Search
 * button, and this is what keeps that from being a request per keystroke.
 */
export function useSettled(value: string, ms = 300): string {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    if (value === settled) return undefined;
    const timer = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(timer);
  }, [value, settled, ms]);
  return settled;
}
